import React from "react";
import {subduedTextColour} from "../../../style/styleConsts";
import styled from "styled-components";
import {groupNameMapping} from "../grouping/GroupingTranslator";
import Loader from "../../elements/Loader";

function getOptions(firstGroupingName) {
    const options = [];
    const groupingNames = groupNameMapping;

    Object.keys(groupingNames).forEach(groupNameKey => {
        if (firstGroupingName !== groupNameKey) {
            const displayName = groupingNames[groupNameKey];
            options.push(<option key={groupNameKey}
                                 value={groupNameKey}>
                {displayName}
            </option>);
        }
    });
    return options;
}

const Label = styled.label`
  margin-right: 5px;
  color: ${subduedTextColour};
`;

const LoaderContainer = styled.div`
    margin-left: 12px;
`;

const Container = styled.div`
    display: flex;
`;

const GroupingSelector = ({isLoading, firstGroupingName, selectedGroupingName, onSelect}) => {
    function onGroupingSelect(event) {
        const value = event.target.value;
        onSelect(value !== "none" ? value : undefined);
        window.scroll(0, 0);
    }

    const dropdown =
        <select id="groupingSelect"
                name="groupings"
                value={selectedGroupingName || "none"}
                onChange={onGroupingSelect}>
            {getOptions(firstGroupingName)}
        </select>;
    const loading = isLoading ? <LoaderContainer><Loader/></LoaderContainer> : null;

    return (<Container className="t-secondary-grouping">
            <Label htmlFor="groupingSelect">Subdivided by</Label>
            {dropdown}
            {loading}
        </Container>
    )
};

export default GroupingSelector;